import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogContainer as MatDialogContainer } from "@angular/material/legacy-dialog";

/**
 * The purpose of the class is to define host bindigs that are necessary
 * for proper working. `MatDialogContainer` included them in the component config
 * but in that way the derived classes don't include them.
 * https://github.com/angular/material2/blob/master/src/lib/dialog/dialog-container.ts#L59
 *
 * Note: A proper long-term alternative instead of custom OBG Dialog Container could be
 * the more customizable dialog implementation currently placed in
 * [cdk-experimental](https://github.com/angular/material2/tree/master/src/cdk-experimental/dialog).
 */
@Component({
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: "",
})
export class BaseMatDialogContainer extends MatDialogContainer {
	@HostBinding("class")
	get _class() {
		return "mat-dialog-container";
	}

	@HostBinding("attr.tabindex")
	get _tabindex() {
		return -1;
	}

	@HostBinding("attr.aria-modal")
	get _ariaModal() {
		return true;
	}

	@HostBinding("attr.id")
	get _modalId(): any {
		return this._config.id;
	}

	@HostBinding("attr.role")
	get _role() {
		return this._config.role;
	}

	@HostBinding("attr.aria-label")
	get _ariaLabel() {
		return this._config.ariaLabel || null;
	}

	@HostBinding("attr.aria-describedby")
	get _ariaDescribedBy() {
		return this._config.ariaDescribedBy;
	}
}
